<script setup lang="ts">
import Lianjie from "./../home/repeat/Lianjie.vue";
import Header from "./../home/repeat/Header.vue";
import Scroll from "./../home/repeat/Scroll.vue";
import { useRouter } from "vue-router";
import { ref, reactive } from "vue";
import Navbar from "../home/repeat/Navbar.vue";
import { useI18n } from "vue-i18n";
import axios from "./../../utils/axios";
import { countries } from "./../../utils/countries";
import { computed } from "vue";
import { ElMessage } from "element-plus";
const router = useRouter();
const { t, locale } = useI18n();

// 存储选中的业务类型
const selectedType = ref("");

// 存储选中的个人资料的方式1726820233@qq.com
const selectedSource = ref([]);

// 获取 el-form 节点
const formRef = ref();

// 表单数据
const form = reactive({
  name: "",
  company: "",
  country: "",
  city: "",
  address: "",
  mobile: "",
  email: "", // 新增
  type: "",
  source: [],
  password: "",
  confirmPassword: "",
  description: "",
  countryCode: "",
  // code: ""
});
const countryOptions = computed(() =>
  countries.map((country) => ({
    value: country.code,
    label: `${locale.value === "zh-cn" ? country.zh : country.en} (${
      country.countryCode
    })`,
    code: country.countryCode,
  }))
);
// 表单验证规则
const rules = reactive({
  name: [
    {
      pattern: /^[\u4e00-\u9fa5a-zA-Z]+$/,
      message: t("system.contact.register.rules.name.pattern"),
      trigger: "blur",
    },
    {
      required: true,
      message: t("system.contact.register.rules.name.required"),
      trigger: "blur",
    },
    {
      min: 2,
      max: 15,
      message: t("system.contact.register.rules.name.length"),
      trigger: "blur",
    },
  ],
  company: [
    {
      pattern: /^[\u4e00-\u9fa5a-zA-Z]+$/,
      message: t("system.contact.register.rules.company.pattern"),
      trigger: "blur",
    },
    // {
    //   required: true,
    //   message: t("system.contact.register.rules.company.required"),
    //   trigger: "blur"
    // },
    {
      min: 3,
      max: 15,
      message: t("system.contact.register.rules.company.length"),
      trigger: "blur",
    },
  ],
  mobile: [
    {
      pattern: /^[0-9]{1,4}[-\s]?(?:[0-9]{2,4}[-\s]?){1,3}[0-9]{2,4}$/,
      message: t("system.contact.register.rules.mobile.pattern"),
      trigger: "blur",
    },
    {
      required: true,
      message: t("system.contact.register.rules.mobile.required"),
      trigger: "blur",
    }
  ],
  email: [
    {
      pattern:
        /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
      message: t("system.contact.register.rules.email.pattern"),
      trigger: "blur",
    },
    {
      required: true,
      message: t("system.contact.register.rules.email.required"),
      trigger: "blur",
    },
  ],
  country: [
    {
      required: true,
      message: t("system.contact.register.rules.country.required"),
      trigger: "blur",
    },
  ],
  /*
  password: [
    {
      required: true,
      message: t("system.contact.register.rules.password.required"),
      trigger: "blur",
    },
    {
      pattern:
        /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,20}$/,
      message: t("system.contact.register.rules.password.pattern"),
      trigger: "blur",
    },
  ],
  confirmPassword: [
    {
      required: true,
      message: t("system.contact.register.rules.confirmpassword.required"),
      trigger: "blur",
    },
    {
      validator: (
        _rules: any,
        value: string,
        callback: (arg0: Error | undefined) => void
      ) => {
        if (value !== form.password) {
          callback(new Error("确认密码与密码不匹配"));
        } else {
          callback();
        }
      },
      trigger: "blur",
    },
  ],
  */
  description: [
    {
      required: true,
      message: t("system.contact.register.rules.description.required"),
      trigger: "blur",
    },
  ],
});
const phonePrefix = ref(countries[0].countryCode);
// 修改 handleCountryChange 函数
const handleCountryChange = (value: string) => {
  const country = countries.find((c) => c.code === value);
  if (country) {
    phonePrefix.value = country.countryCode;
    // 根据语言环境选择要传输的国家名称
    form.country = locale.value === "zh-cn" ? country.zh : country.en;
    form.countryCode = country.countryCode;
  }
};
const onSubmit = () => {
  // 执行表单验证
  formRef.value.validate((valid: any) => {
    if (valid) {
      // 表单验证通过，可以提交表单数据
      form.type = selectedType.value;
      form.source = selectedSource.value;
      axios
        .post("/register", form)
        .then((response) => {
          console.log("响应数据:", response); // 添加日志查看响应数据结构
          ElMessage.success("提交成功");
          // 清空表单
          Object.keys(form).forEach(key => {
            form[key] = "";
          });
          selectedType.value = "";
          selectedSource.value = [];
          // 重置表单校验状态
          formRef.value.resetFields();
        })
        .catch((error) => {
          console.error("注册失败:", error);
        });
    }
  });
};
</script>

<template>
  <div class="register">
    <div class="kong">
      <Header> </Header>
    </div>
    <div class="box">
      <div class="image_box">
        <img src="./../../../public/zuche.jpg" alt="" />
      </div>
    </div>
    <div class="main">
      <div class="title">
        <div class="title_li">
          <div class="title_lis">
            <a class="no" href="/">{{ $t("system.contact.register.s_y") }}</a>
            <text>></text>
            <a class="th">{{ $t("system.contact.register.zhu_ce") }}</a>
          </div>
        </div>
      </div>
      <div class="conter">
        <div class="conter_box">
          <div class="wrap">
            <div class="text">
              <p>
                {{ $t("system.contact.register.text_p") }}
              </p>
            </div>
            <!-- from -->
            <div class="wrap_from">
              <el-form
                :model="form"
                ref="formRef"
                :rules="rules"
                label-width="auto"
                style="max-width: 100%"
                label-position="left"
              >
                <!-- name -->
                <el-form-item
                  style="font-size: 18px"
                  :label="$t('system.contact.register.name')"
                  prop="name"
                  required
                >
                  <el-input v-model="form.name" />
                </el-form-item>
                <!--Company Name -->
                <el-form-item
                  :label="$t('system.contact.register.company')"
                  prop="company"
                >
                  <el-input v-model="form.company" />
                </el-form-item>
                <!-- country  -->
                <el-form-item
                  :label="$t('system.contact.register.country')"
                  prop="country"
                  required
                >
                  <el-select
                    v-model="form.country"
                    @change="handleCountryChange"
                  >
                    <el-option
                      v-for="item in countryOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <!-- mobile -->
                <el-form-item
                  :label="$t('system.contact.register.mobile')"
                  prop="mobile"
                  required
                >
                  <el-input v-model="form.mobile">
                    <template #prepend>
                      <span>{{ phonePrefix }}</span>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item
                  :label="$t('system.contact.register.email')"
                  prop="email"
                  required
                >
                  <el-input v-model="form.email" />
                </el-form-item>
                <!-- city -->
                <el-form-item :label="$t('system.contact.register.city')">
                  <el-input v-model="form.city" />
                </el-form-item>
                <!-- address -->
                <el-form-item :label="$t('system.contact.register.address')">
                  <el-input v-model="form.address" />
                </el-form-item>
                <!-- type -->
                <el-form-item
                  :label="$t('system.contact.register.type')"
                  prop="type"
                >
                  <el-radio-group v-model="selectedType">
                    <el-radio :value="'批发商'">{{
                      $t("system.contact.register.t_w")
                    }}</el-radio>
                    <el-radio :value="'零售商'">{{
                      $t("system.contact.register.t_r")
                    }}</el-radio>
                    <el-radio :value="'贸易代理，组织'">{{
                      $t("system.contact.register.t_t")
                    }}</el-radio>
                  </el-radio-group>
                </el-form-item>
              
                <!-- source -->
                <el-form-item
                  class="about"
                  :label="$t('system.contact.register.about')"
                  prop="source"
                >
                  <el-checkbox-group v-model="selectedSource">
                    <el-checkbox value="搜索引擎,如百度、谷歌、360">{{
                      $t("system.contact.register.search")
                    }}</el-checkbox>
                    <el-checkbox value="其他人介绍">{{
                      $t("system.contact.register.others")
                    }}</el-checkbox>
                    <el-checkbox value="我看过晓隆的产品，但没有买过">{{
                      $t("system.contact.register.look")
                    }}</el-checkbox>
                    <el-checkbox value="我购买过晓隆产品">{{
                      $t("system.contact.register.buy")
                    }}</el-checkbox>
                    <br />
                    <el-checkbox value="展览推广">{{
                      $t("system.contact.register.promotion")
                    }}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item
                  :label="$t('system.contact.register.description')"
                  required
                  prop="description"
                >
                  <el-input
                    type="textarea"
                    v-model="form.description"
                  ></el-input>
                </el-form-item>
                <!-- 协议 -->
                <!-- <div class="line_agree">
                  <label>
                    <input type="checkbox" name="agree" />{{
                      $t("system.contact.register.agree")
                    }}
                  </label>
                </div> -->
                <!-- Verification code -->
                <!--<el-form-item-->
                <!--  :label="$t('system.contact.register.code')"-->
                <!--  prop="code"-->
                <!--&gt;-->
                <!--  <el-input class="int" v-model="form.code" />-->
                <!--  <div class="code_img">-->
                <!--    <img src="./../../assets/imgs/下载.png" alt="" />-->
                <!--  </div>-->
                <!--</el-form-item>-->
                <!-- password-->
                <!-- <el-form-item
                  :label="$t('system.contact.register.password')"
                  prop="password"
                  required
                >
                  <el-input v-model="form.password" type="password" />
                </el-form-item>
                <el-form-item
                  :label="$t('system.contact.register.confirmpassword')"
                  prop="confirmpassword"
                  type="password"
                  required
                >
                  <el-input v-model="form.confirmpassword" type="password" />
                </el-form-item> -->
                <!-- primary -->
                <el-form-item>
                  <el-button type="primary" @click="onSubmit">{{
                    $t("system.contact.register.primary")
                  }}</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Lianjie></Lianjie>
    <Scroll v-if="$i18n.locale === 'zh-cn'"></Scroll>
    <Navbar v-if="$i18n.locale === 'en'"> </Navbar>
  </div>
</template>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.kong {
  max-width: 1200px;
  height: 120px;
}

.box {
  position: relative;
}

.image_box {
  padding-top: 18.23%;
  min-height: inherit;
  max-height: 350px;
  display: block;
  position: relative;
  overflow: hidden;
  height: 0;
}

.image_box img {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  -webkit-transition: all 0.6s linear;
  transition: all 0.6s linear;
}

.main {
  width: 100%;
  height: 1310px;
  background-color: #fff;
}

.title {
  width: 100%;
  line-height: 26px;
  padding: 30px 0;
}

.title_li {
  width: 1230px;
  margin: 0 auto;
  padding: 0 15px;
  box-sizing: border-box;
}

.title_lis {
  width: 1200px;
  height: 100%;
  font-size: 18px;
}

.no {
  width: 36px;
  height: 26px;
  text-decoration: none;
  outline: none;
  color: #3e3a39;
  padding: 0 10px 0 0;
  font-weight: bold;
}

.th {
  width: 36px;
  height: 26px;
  text-decoration: none;
  outline: none;
  color: #3e3a39;
  font-weight: bold;
  padding: 0 0 0 10px;
}

.conter {
  width: 100%;
  height: 1064px;
  padding-bottom: 60px;
}

.conter_box {
  width: 100%;
  margin: 0 auto;
  height: 764.6px;
  padding: 0 15px;
  max-width: 1230px;
}

.wrap {
  max-width: 1090px;
  height: 1164px;
}

.text {
  font-size: 16px;
  width: 100%;
  height: 26px;
  line-height: 26px;
}

.text p {
  margin: 0;
}

.wrap_from {
  width: 1090px;
  font-size: 18px;
  color: #3e3a39;
  height: 1052px;
  margin-top: 50px;
  padding-top: 50px;
  border-top: 2px solid rgba(185, 186, 185, 0.7);
}

.el-input {
  box-shadow: 0px 2px 5px 0px rgba(121, 121, 121, 0.73);
  border-radius: 8px;
}

.el-form-item {
  width: 60%;
  margin: 0;
  height: 60px;
  align-items: center;
  padding: 15px 0;
}

.el-input__wrapper {
  padding: 7px 24px;
  font-size: 16px;
  height: 30px;
}

.about,
.type,
.business {
  width: 50%;
  height: 120%;
  align-items: flex-start;
}

.el-checkbox-group {
  padding-left: 40px;
}

.line_agree {
  padding: 15px 0;
  color: #606060;
}

.line_agree input {
  margin-right: 20px;
}

.int {
  width: 50%;
}

.code_img {
  position: absolute;
  right: 0;
  top: 0;
  width: 25%;
  height: 100%;
  box-shadow: 0px 2px 5px 0px rgba(121, 121, 121, 0.73);
  border-radius: 8px;
}

.code_img img {
  position: absolute;
  right: -18px;
  top: 6px;
  width: 100%;
  height: 100%;
}

.el-form-item {
  position: relative;
}

.el-button {
  background-color: #3c93cc;
  color: #fff;
  outline: none;
}
.el-select {
  width: 100%;
}

.el-input-group__prepend {
  padding: 0 10px;
  background-color: #f5f7fa;
  color: #909399;
  min-width: 70px;
  text-align: center;
}
</style>